import css from '@styled-system/css';
import styled from 'styled-components';
import { Copy, ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Wrapper')(
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ededed',
    height: '60px',
    zIndex: 1021,
    position: 'relative',
    pr: 'l',
    pl: 'default',
    '@media only screen and (min-width: 1074px)': {
      px: '40px',
    },
  }),
);

themeStyles.addBaseStyles('Row')(({ theme }) =>
  css({
    width: '100%',
    height: '100%',
    marginY: 0,
    marginX: [`-${theme?.space.xxs}px`, `-${theme?.space.xxs}px`, `-${theme?.space.m}px`],
  }),
);

themeStyles.addBaseStyles('Column')(({ display }) =>
  css({
    display: display || 'flex',
    height: '100%',
    alignItems: 'center',
    '& >:first-child': {
      pl: 'zero',
    },
  }),
);

themeStyles.addBaseStyles('Item')(({ showIcon, theme }) =>
  css({
    height: '100%',
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    fontSize: '14px',
    lineHeight: '24px',
    paddingX: showIcon ? 's' : 'zero',
    textDecoration: 'none',
    ':before': {
      position: 'absolute',
      top: '17px',
      left: 0,
      zIndex: 1,
      width: '1px',
      backgroundColor: 'grey.1',
      height: '26px',
      content: '""',
    },
    ':first-child': {
      '&:before': {
        content: 'none',
      },
    },
    opacity: showIcon ? 0.6 : 1,
    '&:hover': {
      opacity: 1,
    },
    '&:focus-visible': {
      outline: `solid 2px ${theme.colors.aodaFocused}`,
    },
  }),
);

themeStyles.addBaseStyles('NavIconWrapper')(
  css({
    height: '100%',
    width: 'inherit',
  }),
);

themeStyles.addBaseStyles('NavIcon')(
  css({
    maxHeight: '26.25px',
    mr: 0,
    objectFit: 'contain',
  }),
);

export const NavLabel = styled(Copy)(
  css({
    color: 'grey.0',
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.5px',
    fontFamily: 'bold',
  }),
);

export default themeStyles;
